// Single source of truth for every brand hex in the runtime — zinc plus one
// saturated accent family, never a third neutral hue. Mirror surfaces
// (scripts/identity/*.html) and the theme-color metas in index.html must
// match these values; the palette sync test fails the build on drift.
//
// RÉSUMÉ INVERSION (portfolio BRAND.md, résumé recipe): the palette matches
// the portfolio role-for-role, but this app renders the page field on
// `surface` and the paper sheets on `background`, so the sheet reads as the
// darkest object. The swap lives in ThemeProvider.
export const PALETTE = {
    dark: {
        background: "#09090B",
        primaryText: "#E4E4E7",
        secondaryText: "#A1A1AA",
        accent: "#FBBF24",
        // accent darkened a step (lightness only, never a hue jump),
        // surround-tuned per mode
        accentHover: "#E7B021",
        surface: "#111113",
        border: "#27272A",
        // decorative meta only — never informational text; solid, never
        // alpha. zinc-500 fails AA here; this zinc-400/500 midpoint holds
        // ~5.4:1 on both dark surfaces
        faint: "#898992",
        // fox-only decorative glow (hero art + swarm), never text
        foxGlow: "#FBBF24",
        // the mark's fill (favicon, og) and the wordmark period
        fox: "#F97316",
    },
    light: {
        background: "#FAFAFA",
        primaryText: "#18181B",
        secondaryText: "#52525B",
        accent: "#D1400A",
        // accent darkened a step — the lighter hover washed filled text to
        // 2.55:1 on white
        accentHover: "#C43C09",
        surface: "#F4F4F5",
        border: "#E4E4E7",
        // ornaments only — on the raised surface it dips below AA, so
        // readable meta takes secondaryText
        faint: "#71717A",
        // fox-only decorative glow, never text — the yellowest step still
        // visible as a hot spot on white
        foxGlow: "#FBA80C",
        // the mark's fill (favicon, og) and the wordmark period
        fox: "#EA580C",
    },
} as const

export type PaletteMode = keyof typeof PALETTE

export type Palette = (typeof PALETTE)[PaletteMode]
